/*
 * Mushroom house — the cozy little dwellings around the square.
 * Cap color varies per house; stalk/door/window are constant.
 */

import { Container, Graphics } from 'pixi.js';

export function createMushroomHouse(x: number, y: number, capColor: number): Container {
  const root = new Container();
  root.position.set(x, y);

  const g = new Graphics();

  // Stalk.
  g.ellipse(0, 22, 22, 30).fill(0xf5ebd0);
  // Stalk shadow.
  g.ellipse(-8, 22, 6, 24).fill({ color: 0x000000, alpha: 0.08 });

  // Door.
  g.ellipse(0, 32, 6.5, 11).fill(0x3a2410);
  g.circle(3, 33, 0.7).fill(0x5c3d28);

  // Window.
  g.circle(-11, 14, 4).fill(0x3a2410);
  g.circle(-11, 14, 2.8).fill(0xffc56b);
  g.circle(-11, 14, 8).fill({ color: 0xffc56b, alpha: 0.25 });

  // Cap.
  g.ellipse(0, -4, 34, 24).fill(capColor);
  // Cap shading on the right (top hemisphere only — we clip with another ellipse
  // overlay rather than recreating the half-ellipse from v0.2).
  g.ellipse(12, -2, 18, 18).fill({ color: 0x000000, alpha: 0.15 });

  // White cap dots.
  g.circle(-13, -9, 4.5).fill(0xfff4dc);
  g.circle(7, -13, 3.5).fill(0xfff4dc);
  g.circle(17, -5, 4).fill(0xfff4dc);
  g.circle(-5, -15, 2.5).fill(0xfff4dc);

  root.addChild(g);
  return root;
}
